export default {
  callLogs: 'Journal d\'appel',
  emptyCallLogs: 'Aucun journal d\'appel trouvé',
};
